import React,{useEffect,useState} from 'react'
import RegisterHeader from '../../components/common/RegisterHeader'
// import RegisterForm from '../../components/Auth/RegisterForm'
import { Link,useNavigate,useLocation } from 'react-router-dom'
import queryString from 'query-string'
// import StudentImg from '../../assets/images/register-right.png'
import RegisterClosedImg from '../../assets/images/registration-closed.png'

const Register = () => {

    const navigate = useNavigate();
    const[utmParams,setUtmParams]=useState({})
    const location = useLocation();

    useEffect(() => {
        window.gtag("config", "UA-185641939-1", {
        page_title: location.pathname,
        page_path:location.pathname,
        })
      }, [location]);
      
        useEffect(() => {
          window.gtag("config", "GTM-WD9H59N", {
          page_title: location.pathname,
          page_path:location.pathname,
          })
      }, [location]);
      
    useEffect(() => {
        if(sessionStorage.getItem('token')){
            navigate('/student/dashboard');
        }
        const qParams = queryString.parse(location.search);
        if (qParams !== null) {
            const{channel_name,current_channel_name,source,lead_source,campaign_name,utm_adgroup,utm_campaign,utm_medium,utm_source,utm_term} =qParams
            let utmObj={
                channel_name:channel_name?channel_name:'',
                current_channel_name:current_channel_name?current_channel_name:'',
                source:source?source:'',
                lead_source:lead_source?lead_source:'',
                campaign_name:campaign_name?campaign_name:'',
                utm_adgroup:utm_adgroup?utm_adgroup:'',
                utm_campaign:utm_campaign?utm_campaign:'',
                utm_medium:utm_medium?utm_medium:'',
                utm_source:utm_source?utm_source:'',
                utm_term:utm_term?utm_term:'',
            }
            setUtmParams(utmObj)
        }
    },[])

    
  return (
    <>
    <RegisterHeader/>
    <div className="container mt-5">
        <div className="row gx-lg-4  login_register_form register_form_wrapper">
            <div className="col-md-12  mx-auto">
                <div className="register_left login_left text-center">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <img src={RegisterClosedImg} className='close_register_img' alt="closed icon" />
                            <h2>Admissions Closed for 2024-2025!</h2>
                            {/* <p>Already Have an account ? <Link to="/login" className="text-decoration-none text-primary fw-bold" title="Login Here">Please Login Here</Link></p> */}
                        </div>
                        {/* <div className="col-lg-6 align-self-end">
                            <p className="fw-bold text-danger">* All Fields are mandatory </p>
                        </div> */}
                    </div>
                    {/* <RegisterForm utmParams={utmParams}/> */}
                    <div className="register_close_msg mt-4">
                  
                        <p>We are immensely grateful to all the students for their overwhelming response to the admissions<br/> for the  academic session 2024-2025. Admissions are now closed for this session.</p>
                        
                        <p className='mt-4'>If you have already registered, you can access your profile by clicking the button below:</p>

                        <Link to="/login" className="btn btn-sm text-white px-4 mt-0 mb-2 bg-primary" title="Login Here">Login to your profile</Link>

                        <p className='mt-4'>For admissions in the academic session 2025-2026, please click the button below to stay updated:</p>
                        <a href="https://allenoverseas.com/student/20252026" className="btn btn-sm text-white px-4 mt-1 bg-secondary">Apply for 2025-2026 Admissions</a>
  
                    </div>
                </div>
            </div>
       
            {/* Instructions */}
            {/* <div className="col-md-4">
                <img src={StudentImg} className='img-fluid d-none d-lg-block' alt="Register student" />
                
            </div> */}
        </div>
    </div>
</>

  )
}

export default Register


